import { computed } from 'vue'
import { useDisplay } from 'vuetify'

/**
 * Provides responsive dialog widths and design system helpers.
 * Replaces the repeated `$vuetify.display.smAndDown ? 'auto' : 650` pattern.
 */
export function useDesignSystem() {
  const { smAndDown } = useDisplay()

  /**
   * Returns a computed responsive width for dialogs.
   * On small screens returns 'auto' (full-width); on larger screens returns the token width.
   * @param {'xs'|'sm'|'md'|'lg'|'xl'|number} size - Named size or explicit pixel value
   * @returns {import('vue').ComputedRef<string|number>}
   */
  function dialogWidth(size = 'md') {
    const widths = {
      xs: 400,
      sm: 500,
      md: 650,
      lg: 900,
      xl: 1100,
    }

    const px = typeof size === 'number' ? size : widths[size] || widths.md

    return computed(() => smAndDown.value ? 'auto' : px)
  }

  return {
    dialogWidth,
    smAndDown,
  }
}
